import script from "./SogScheduleSerieLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogScheduleSerieLabel.vue?vue&type=script&setup=true&lang=ts"

import "./SogScheduleSerieLabel.vue?vue&type=style&index=0&id=7252af8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7252af8e"]])

export default __exports__